<template>
  <role-form
    :role="role"
    :submit="submit"
    :onInput="onInput"
    :loading="loading"
    :buttonText="$t('create')"
    :title="$t('roleCreate')"
  />
</template>

<script setup lang="ts">
import { ref, computed, onBeforeMount } from 'vue';
import { useStore } from 'vuex';
import Say from '@/utils/Say';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import sayErrorResponse from '@/mixins/sayErrorResponse';
import RoleForm from './Form.vue';

const loading = ref(false);
const store = useStore();
const { t } = useI18n();
const router = useRouter();

const role = computed(() => store.getters.roleCreate);

const onInput = (name: string, value: any) => {
  store.commit('roles.createUpdateInput', { name, value });
};

onBeforeMount(async () => {
  store.commit('roles.createClear');
  await store.dispatch('permissions.fetch');

  store.commit('app.setPageTitle', t('roleCreate'));
  store.commit('app.setBreadcrumbs', [
    { text: t('role', 2), routeName: 'Roles' },
    { text: t('roleCreate') }
  ]);
});

const submit = () => {
  loading.value = true;

  store.dispatch('roles.create')
    .then((id: number|string) => {
      // Display success
      loading.value = false;
      Say('success', t('roleCreateSuccess'));
      router.push({ name: 'RolesEdit', params: { id } });
    })
    .catch(err => {
      loading.value = false;
      sayErrorResponse(err)
    });
};
</script>
